import type { Element, Root } from 'hast';
import { visit } from 'unist-util-visit';

const INDENT_MULTIPLIER_REM = 2;
const MARGIN_LEFT_PATTERN = /margin-left\s*:/i;

export function rehypeIndent() {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element) => {
      const indent = node.properties?.dataIndent;

      if (indent === undefined || indent === null) {
        return;
      }

      const level = Number(indent);
      if (isNaN(level) || level <= 0) {
        return;
      }

      const style = node.properties?.style;
      const existingStyle = typeof style === 'string' ? style : '';

      if (MARGIN_LEFT_PATTERN.test(existingStyle)) {
        return;
      }

      const marginLeft = `margin-left: ${level * INDENT_MULTIPLIER_REM}rem`;
      node.properties = node.properties ?? {};
      node.properties.style = existingStyle
        ? `${existingStyle}; ${marginLeft}`
        : marginLeft;
    });
  };
}
